<template>
  <div>
    <p v-if="user && user.onlineType == 'GDI'" class="mainTxt">GDI</p>
    <p v-else class="mainTxt">PGDI</p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Home",
  computed: mapState(["user"]),
};
</script>

<style scoped>
.mainTxt {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 1400%;
  font-weight: bold;
  color: #ff9a2e;
  opacity: 0.6;
  height: 75vh;
  margin: auto;
  transition-duration: 0.7s;
  cursor: default;
  -webkit-touch-callout: none; /* iPhone OS, Safari */
  -webkit-user-select: none; /* Chrome, Safari 3 */
  -khtml-user-select: none; /* Safari 2 */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */
}
@media (max-width: 600px) {
  .mainTxt {
    font-size: 1000%;
  }
}

@media (max-width: 450px) {
  .mainTxt {
    font-size: 700%;
  }
}
</style>
